import type { InvoiceStatusType } from 'api/swagger';
import { createStore } from './create-store';

export interface IInvoicesFilter {
  statuses?: InvoiceStatusType[];
  clientId?: {
    value: number;
    label?: string;
  };
  overdue?: boolean;
}

type TState = {
  search: string;
  filters?: IInvoicesFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: IInvoicesFilter | undefined) => void;
};

export const useInvoiceFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: IInvoicesFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'invoice-filters-store',
);
